import React from 'react'
import { EventsContext } from '../contexts/EventsProvider'

export const useEvents = () => React.useContext(EventsContext)
